// src/pages/FAQ.tsx
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";

const FAQ = () => {
  return (
    <div className="min-h-screen p-6 bg-background">
      <div className="max-w-4xl mx-auto space-y-8">
        <h1 className="text-4xl font-bold tracking-tight bg-gradient-to-r from-purple-500 to-blue-500 bg-clip-text text-transparent">
          Frequently Asked Questions
        </h1>
        
        <Accordion type="single" collapsible className="w-full">
          <AccordionItem value="item-1">
            <AccordionTrigger className="text-lg font-semibold">
              How do I use the Screen Tool?
            </AccordionTrigger>
            <AccordionContent className="text-muted-foreground leading-relaxed">
              Simply select a color from the predefined palette or enter a custom hex color code. 
              Click the fullscreen button to display the color in fullscreen mode. You can also 
              download the background in your preferred resolution.
            </AccordionContent>
          </AccordionItem>

          <AccordionItem value="item-2">
            <AccordionTrigger className="text-lg font-semibold">
              How do I exit fullscreen mode?
            </AccordionTrigger>
            <AccordionContent className="text-muted-foreground leading-relaxed">
              There are several ways to exit fullscreen mode:
              <ul className="list-disc list-inside mt-2 space-y-1">
                <li>Press ESC key on Windows</li>
                <li>Press Command + Control + F on Mac</li>
                <li>Click the minimize button in the top-right corner</li>
              </ul>
            </AccordionContent>
          </AccordionItem>

          <AccordionItem value="item-3">
            <AccordionTrigger className="text-lg font-semibold">
              Can I download the background?
            </AccordionTrigger>
            <AccordionContent className="text-muted-foreground leading-relaxed">
              Yes! Select your desired resolution from the dropdown menu and click the 
              "Download Background" button to save the color as a PNG file.
            </AccordionContent>
          </AccordionItem>

          <AccordionItem value="item-4">
            <AccordionTrigger className="text-lg font-semibold">
              What resolutions are supported?
            </AccordionTrigger>
            <AccordionContent className="text-muted-foreground leading-relaxed">
              We support common resolutions including:
              <ul className="list-disc list-inside mt-2 space-y-1">
                <li>720p (1280×720)</li>
                <li>1080p (1920×1080)</li>
                <li>1440p (2560×1440)</li>
                <li>4K (3840×2160)</li>
              </ul>
              You can also enter custom dimensions if needed.
            </AccordionContent>
          </AccordionItem>
        </Accordion>
      </div>
    </div>
  );
};

export default FAQ;